let accessToken = null;

const listeners = new Set();
const notify = () => listeners.forEach((listener) => listener());

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
  accessToken = token;
  notify();
};

export const clearAccessToken = () => setAccessToken(null);

export const subscribeAccessToken = (listener) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};
